export enum TimeZonesEnum {
	Atlantic = 'Canada/Atlantic',
	Eastern = 'US/Eastern',
	Central = 'US/Central',
	Mountain = 'US/Mountain',
	Pacific = 'US/Pacific',
	Alaska = 'US/Alaska',
	HawaiiAleutian = 'US/Hawaii',
	Samoa = 'US/Samoa',
	Chamorro = 'Pacific/Guam',
}
